import { make } from 'vuex-pathify'
import axios from 'axios'
import { AZURE_SEARCH_DEFAULT_AXIOS_CONFIG } from '@/config/azure-search'

const state = {
  people: [],
  completeFacets: { jobTypes: [], office: [], organization: [] },
  filteredFacets: { jobTypes: [], office: [], organization: [] },
  enableFuzzySearch: true,

  selectedOrganizations: [],
  selectedOffices: [],
  selectedJobTypes: [],
}

export default {
  namespaced: true,

  state,

  mutations: make.mutations(state),

  actions: {
    ...make.actions(state),

    // async getPeople({ commit }) {
    //   let { data: people } = await axios.get('/mock-api/people.json')

    //   commit('SET_PEOPLE', people)
    // },

    async queryPeople({ commit, getters }) {
      // Query azure search
      let { data } = await axios({
        ...AZURE_SEARCH_DEFAULT_AXIOS_CONFIG,
        url: `${process.env.VUE_APP_AZURE_SEARCH_ENDPOINT}/indexes/people-index/docs/search`,
        data: getters.searchPayload,
      })

      // Update state
      if (data && data.value) {
        commit('SET_PEOPLE', data.value)
        commit('SET_FILTERED_FACETS', data['@search.facets'])
      }
      return data.value
    },

    async getFilters({ commit }) {
      // Query azure search
      let { data } = await axios({
        ...AZURE_SEARCH_DEFAULT_AXIOS_CONFIG,
        url: `${process.env.VUE_APP_AZURE_SEARCH_ENDPOINT}/indexes/people-index/docs/search`,
        data: {
          count: true,
          facets: [
            'office,count:1000',
            'organization,count:1000',
            'jobTypes,count:1000',
          ],
          top: 1,
          select: 'id',
        },
      })

      // Update state
      if (data && data.value) {
        commit('SET_COMPLETE_FACETS', data['@search.facets'])
      }
      return data.value
    },

    clearFilters({ commit }) {
      commit('SET_SELECTED_ORGANIZATIONS', [])
      commit('SET_SELECTED_OFFICES', [])
      commit('SET_SELECTED_JOB_TYPES', [])
    },
  },

  getters: {
    organizations: state => {
      return state.completeFacets.organization
        .map(p => p.value)
        .reduce((a, o) => {
          if (!!o && a.indexOf(o) === -1) a.push(o)
          return a
        }, [])
        .sort()
    },

    organizationOptions: (state, getters) => {
      return getters.organizations.map(o => ({
        text: o,
        value: o,
      }))
    },

    offices: state => {
      return state.completeFacets.office
        .map(p => p.value)
        .reduce((a, o) => {
          if (!!o && a.indexOf(o) === -1) a.push(o)
          return a
        }, [])
        .sort()
    },

    officeOptions: (state, getters) => {
      const facets =
        state.filteredFacets && state.filteredFacets.hasOwnProperty('office')
          ? state.filteredFacets.office
          : null

      return getters.offices
        .reduce((a, o) => {
          if (!!o && a.indexOf(o) === -1) a.push(o)
          return a
        }, [])
        .map(j => {
          const facet = facets ? facets.find(f => f.value === j) : null

          return {
            text: j,
            value: j,
            count: facet ? facet.count : 0,
          }
        })
        .filter(o => o.count > 0)
    },

    jobTypeOptions: state => {
      const facets =
        state.filteredFacets && state.filteredFacets.hasOwnProperty('jobTypes')
          ? state.filteredFacets.jobTypes
          : null

      return state.completeFacets.jobTypes
        .map(jt => jt.value)
        .sort()
        .map(j => {
          const facet = facets ? facets.find(f => f.value === j) : null

          return {
            text: j,
            value: j,
            count: facet ? facet.count : 0,
          }
        })
    },

    searchPayload: (state, getters, rootState) => {
      let query = '*'

      if (state.enableFuzzySearch) {
        // Search both by exact phrase and by fuzzy search of event name
        query = rootState.keywords.trim() ? `${rootState.keywords.trim()}` : '*'
      } else {
        query = rootState.keywords.trim()
      }

      let filters = []

      if (
        rootState.selectedOrganizationId &&
        rootState.selectedOrganizationId !==
          '26eaf390-d8ab-11e9-a3a8-5de5bba4f125'
      ) {
        filters.push(`organizationId eq '${rootState.selectedOrganizationId}'`)
      }

      if (state.selectedOffices.length > 0) {
        filters.push(
          `search.in(office, '${state.selectedOffices.join(',')}', ',')`
        )
      }

      if (state.selectedJobTypes.length > 0) {
        filters.push(
          `jobTypes/any(t: search.in(t, '${state.selectedJobTypes.join(
            ','
          )}', ',')) `
        )
      }

      let payload = {
        count: true,
        queryType: state.enableFuzzySearch ? 'full' : 'simple',
        search: query,
        filter: filters.join(' and '),
        facets: ['office,count:1000', 'jobTypes,count:1000'],
        top: 250,
      }

      if (query === '*') {
        payload.orderby = 'lastName asc'
      }

      return payload
    },

    totalFiltersApplied: state => {
      return (
        state.selectedOffices.length +
        state.selectedJobTypes.length +
        state.selectedOrganizations.length
      )
    },

    filteredPeopleCount: state => {
      return state.people.length
    },

    filteredPeopleListItems: state => {
      return state.people.map(p => {
        return {
          person: { ...p, thumbnailUrl: '' },
          label: `${p.displayName}`,
          // thumbnail: p.picture.thumbnail,
          textAvatar: p.displayName
            .split(' ')
            .map(n => n[0])
            .join(''),
          description: `${p.jobTitles
            .map(t => t.replace('Teacher: ', 'Teacher, ').replace(/.+: /g, ''))
            // .concat(p.groups || [])
            .join(', ')}`,
          // </strong><br><small>${p.office}</small>`,

          badge: '',
          condensed: false,
          actionable: true,
          bordered: true,
          checked: false,
          alignTop: true,
          tags: p.groups.length ? p.groups : p.office ? [p.office] : [],
          // to: `people/${p.id.value}`,
        }
      })
    },
  },
}
